// extracted by mini-css-extract-plugin
export default {"e_otp_wrapper":"otpInput_e_otp_wrapper__O2qKQ"};